import React from "react";
import PropTypes from "prop-types";
import LinkGroup from "./link-group";

const MainLinkList = ({ data }) => {
  return (
    <>
      <div className="main-link-list-section container">
        <div className="content">
          {data &&
            data.map((d) => (
              <LinkGroup title={d?.title} items={d?.items} key={d?.title} />
            ))}
        </div>
      </div>      
    </>
  );
};

export default MainLinkList;

MainLinkList.propTypes = {
  /**
   * {
   *  "info": "Lista de objetos con el título del bloque y los datos de los enlaces anidados",
   *  "kind": "both",
   *  "beautifulName": "Información del bloque"
   * }
   */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.array,
    })
  ),
};

MainLinkList.defaultProps = {
  data: [],
};
